import { type FC } from 'react';
import { toast } from 'react-toastify';

import { useDeleteSavedView } from '../hooks/useSavedViewMutations';
import { RemoveViewModal } from '../views/RemoveViewModal';

interface RemoveViewModalControllerProps {
  handleClose: () => void;
  viewId: string;
}

export const RemoveViewModalController: FC<RemoveViewModalControllerProps> = ({ handleClose, viewId }) => {
  const { mutate, isPending } = useDeleteSavedView();

  const handleConfirm = () =>
    mutate(viewId, {
      onSuccess: () => {
        toast.success('Filtered view removed');
        handleClose();
      },
      onError: () => toast.error('Unable to remove view'),
    });

  return <RemoveViewModal isLoading={isPending} onCancel={handleClose} onConfirm={handleConfirm} />;
};
